import React, { FC, useState } from 'react';
import { Box, CircularProgress, Container, Grid, makeStyles, Theme, Typography, useMediaQuery } from '@material-ui/core';
import { Field, Form } from 'react-final-form';
import { useFormSender } from 'hooks';
import { API_CAREER_ROUTE } from 'data/api-routes';
import { Checkbox, SpacingLayout, SubmitButton, TextInput } from 'components/atoms';
import { careerValidation } from 'data/validators/career';
import { parsePhoneOnType } from 'utils/phoneHelpers';

const useStyles = makeStyles({
  container: {
    paddingTop: 0,
  },
});

const CareerForm: FC = () => {
  const classes = useStyles();
  const {
    onSubmit,
    status: { error, loading, success },
  } = useFormSender(API_CAREER_ROUTE);
  const isLarge = useMediaQuery((theme: Theme) => theme.breakpoints.up('sm'));
  const [checked, setChecked] = useState<boolean>(false);
  const isSubmitted = success || loading;
  const handleSubmit = async (values, actions, cb) => {
    await onSubmit(values, actions, cb, { chose: checked ? 'YES' : 'NO' });
  };
  return (
    <SpacingLayout className={classes.container}>
      <Container>
        <Grid container>
          {isLarge && <Grid item sm={2} />}
          <Grid item sm={8} xs={12}>
            <Typography variant="h2" color="primary">
              <span>JOIN OUR CARRIER NETWORK</span>
            </Typography>
            <Box mb={8} mt={2}>
              <Typography>Fill in the form and become a carrier</Typography>
            </Box>
            <Form
              onSubmit={handleSubmit}
              validate={careerValidation}
              render={({ handleSubmit, submitting }) => (
                <form onSubmit={handleSubmit}>
                  <Grid spacing={6} container>
                    <Grid item md={6} sm={12} xs={12}>
                      <Field name="firstName">
                        {({ input, meta: { error, touched } }) => (
                          <TextInput
                            {...input}
                            disabled={isSubmitted}
                            type="text"
                            error={error && touched}
                            hintMessage={touched && error}
                            required
                            label={'First Name'}
                          />
                        )}
                      </Field>
                      <Box py={1} />
                    </Grid>
                    <Grid item md={6} xs={12}>
                      <Field name="lastName">
                        {({ input, meta: { error, touched } }) => (
                          <TextInput
                            {...input}
                            disabled={isSubmitted}
                            type="text"
                            error={error && touched}
                            hintMessage={touched && error}
                            required
                            label={'Last Name'}
                          />
                        )}
                      </Field>
                      <Box py={1} />
                    </Grid>
                    <Grid item md={6} sm={12} xs={12}>
                      <Field name="companyName">
                        {({ input, meta: { error, touched } }) => (
                          <TextInput
                            {...input}
                            disabled={isSubmitted}
                            required
                            error={error && touched}
                            hintMessage={touched && error}
                            label={'Company Name'}
                          />
                        )}
                      </Field>
                      <Box py={1} />
                    </Grid>
                    <Grid item md={6} sm={12} xs={12}>
                      <Field name="DOTNumber">
                        {({ input, meta: { error, touched } }) => (
                          <TextInput
                            {...input}
                            number
                            disabled={isSubmitted}
                            required
                            error={error && touched}
                            hintMessage={touched && error}
                            label={'DOT Number'}
                          />
                        )}
                      </Field>
                      <Box py={1} />
                    </Grid>
                    <Grid item md={6} sm={12} xs={12}>
                      <Field name="email">
                        {({ input, meta: { error, touched } }) => (
                          <TextInput
                            {...input}
                            disabled={isSubmitted}
                            required
                            error={error && touched}
                            hintMessage={touched && error}
                            label={'Email'}
                          />
                        )}
                      </Field>
                      <Box py={1} />
                    </Grid>
                    <Grid item md={6} sm={12} xs={12}>
                      <Field parse={parsePhoneOnType} name="phone">
                        {({ input, meta: { error, touched } }) => (
                          <TextInput
                            disabled={isSubmitted}
                            {...input}
                            required
                            error={error && touched}
                            hintMessage={touched && error}
                            label={'Phone Number'}
                          />
                        )}
                      </Field>
                    </Grid>
                  </Grid>
                  <Box mt={6} mb={6}>
                    <Field name="message">
                      {({ input, meta: { error, touched } }) => (
                        <TextInput
                          {...input}
                          disabled={isSubmitted}
                          type="text"
                          multiline
                          error={error && touched}
                          hintMessage={touched && error}
                          label={'Your message'}
                          rows={10}
                        />
                      )}
                    </Field>
                  </Box>
                  <Box display="flex">
                    <SubmitButton disabled={submitting} error={error} success={success}>
                      {loading && <CircularProgress size="30px" color="secondary" />}
                      {success && 'Thank you for filling out your information!'}
                      {error && 'Error message'}
                      {!loading && !success && !error && 'Send'}
                    </SubmitButton>
                    {!error && !success && (
                      <>
                        <Box mx={3} />
                        <Checkbox
                          value={checked}
                          onChange={setChecked}
                          title={'Are you a registered carrier with Patron Trucking?'}
                        />
                      </>
                    )}
                  </Box>
                </form>
              )}
            />
          </Grid>
          {isLarge && <Grid item sm={2} />}
        </Grid>
      </Container>
    </SpacingLayout>
  );
};

export default CareerForm;
